// extracted by mini-css-extract-plugin
export var card = "_7c-0";
export var failedIcon = "_7c-4";
export var failedIconBadge = "_7c-3";
export var icon = "_7c-1";
export var successIcon = "_7c-2";